<template>
    <div class="bg-light">
        <mobile-header>
            <div class="pl-2">
                <brand-link />
            </div>
        </mobile-header>

        <div id="main" class="d-block">
            <router-view v-if="$route.meta.public"></router-view>
        </div>
    </div>
</template>


<script>
import MobileHeader from "@/components/layout/MobileHeader";
import BrandLink from "@/components/utility/BrandLink";

export default {
    created() {
        // social app defaults
        document.body.classList.remove("keep-padding");
    },
    components: {
        BrandLink,
        MobileHeader,
    },
};
</script>
        